<template>
   <section class="landingscreen" v-bind:class="{'landingscreen--active': landingTrigActive}">

      <div class="landingscreen__trigger" @click="landingTrigger"></div>

      <div class="container" v-if="screenId === '3'">
         <div class="landingscreen__logo">
            <div class="landingscreen__buildinglogo">
               <img src="../assets/img/bailey-logo-white.png" alt="Master logo"/>
            </div>
         </div>
      </div>
		<div class="landingscreen__img" v-bind:style="{ background: 'url(' + bgImg + ')' + 'no-repeat center center' }"></div>
<!--
		<div class="landingscreen__video">
			<video autoplay loop muted>
				<source v-bind:src="bgImg" type="video/mp4">
			</video>
		</div>
-->
      <div class="landingscreen__over"></div>
		<div class="landingscreen__come-play">
			<span>Touch screen to book tours
				<svg enable-background="new 0 0 24 24" version="1.1" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
					<path d="M18,10h-1.086c-0.206-0.582-0.762-1-1.414-1h-1.586c-0.206-0.582-0.762-1-1.414-1H11V4c0-1.103-0.897-2-2-2S7,2.897,7,4  v10.414l-1.832-1.57c-0.65-0.561-1.7-0.521-2.308,0.089c-0.587,0.587-0.664,1.505-0.209,2.147C2.813,15.354,6.601,21.8,8.1,23.8  C8.194,23.926,8.343,24,8.5,24h9c0.224,0,0.419-0.148,0.48-0.363l1.615-5.653C19.864,17.044,20,16.073,20,15.099V12  C20,10.897,19.103,10,18,10z M19,15.099c0,0.881-0.123,1.76-0.365,2.611L17.123,23h-8.37c-1.562-2.167-5.201-8.363-5.262-8.461  c-0.197-0.279-0.165-0.658,0.076-0.899c0.249-0.25,0.682-0.267,0.95-0.037l2.657,2.278c0.147,0.126,0.358,0.155,0.534,0.074  C7.887,15.873,8,15.695,8,15.5V4c0-0.551,0.448-1,1-1s1,0.449,1,1v4v0.5v3h1V9h1.5C12.775,9,13,9.224,13,9.5v2h1V10h1.5  c0.275,0,0.5,0.224,0.5,0.5v2h1V11h1c0.552,0,1,0.449,1,1V15.099z"/>
				</svg>
			</span>
		</div>
   </section>

</template>

<script>
   export default {
      name: 'LandingScreens',
      props: ['bgImg', 'screenId'],
      data() {
         return {
            landingTrigActive: true,
         }
      },
      methods: {
         landingTrigger(){
            this.landingTrigActive = !this.landingTrigActive;
         }
      },
   }
</script>
